"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = index;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
function index(props) {
  var _a = props.radioTxtList,
    radioTxtList = _a === void 0 ? [] : _a,
    style = props.style;
  var _b = (0, _react.useState)(0),
    active = _b[0],
    setActive = _b[1];
  var onChangeSelect = function onChangeSelect(index) {
    setActive(index);
  };
  var allList = [];
  radioTxtList.forEach(function (item) {
    var _a = item.configuration,
      configuration = _a === void 0 ? [] : _a;
    configuration === null || configuration === void 0 ? void 0 : configuration.forEach(function (config) {
      allList.push(config);
    });
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "best-practices-selectcard-wrapper",
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "best-practices-selectcard"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "best-practices-selectcard-content"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "selectcard-ul"
  }, radioTxtList.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: "selectCard-li",
      key: index
    }, /*#__PURE__*/_react["default"].createElement("label", __assign({
      className: "selectCard-li-radio-btn-wrapper",
      onClick: function onClick() {
        return onChangeSelect(index);
      }
    }, item.extendProps || {}), /*#__PURE__*/_react["default"].createElement("input", {
      type: "radio",
      name: "radio-group"
    }), /*#__PURE__*/_react["default"].createElement("button", __assign({
      className: (0, _classnames["default"])('radio-control', {
        checked: active === index
      }),
      title: "radio-control",
      key: index
    }, item.extendProps || {})), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'radio-control-txt'
    }, item === null || item === void 0 ? void 0 : item.txt)));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "selectcard-list-wrap"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('selectcard-list', {})
  }, radioTxtList.map(function (item, i) {
    var _a = item.configuration,
      configuration = _a === void 0 ? [] : _a;
    var newConfiguration = __spreadArrays(configuration);
    if (i === 0) {
      newConfiguration = __spreadArrays(allList);
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, newConfiguration.map(function (_item, index) {
      var header = _item.header,
        contentTitle = _item.contentTitle,
        contentDesc = _item.contentDesc,
        publishTime = _item.publishTime,
        href = _item.href,
        extendProps = _item.extendProps;
      return /*#__PURE__*/_react["default"].createElement("a", __assign({
        key: index,
        className: (0, _classnames["default"])('selectcard-list-card-wrap', {
          active: active === i
        }),
        href: href
      }, extendProps || {}), /*#__PURE__*/_react["default"].createElement("article", {
        className: "selectcard-list-card"
      }, /*#__PURE__*/_react["default"].createElement("header", {
        className: "selectcard-list-card-title"
      }, header), /*#__PURE__*/_react["default"].createElement("div", {
        className: "selectcard-list-card-content"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "selectcard-list-card-content-title"
      }, contentTitle), /*#__PURE__*/_react["default"].createElement("div", {
        className: "selectcard-list-card-content-desc"
      }, contentDesc), /*#__PURE__*/_react["default"].createElement("div", {
        className: "selectcard-list-card-content-bottom"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "selectcard-list-card-content-bottom-txt"
      }, publishTime)))));
    }));
  }))))));
}